const ratereserved = [{
  desc: '留点设置负责人查询接口',
  options: {
    url: '/ratereserved/queryPageChargeCustomer',
    method: 'post'
  }
}, {
  desc: '留点查询接口',
  options: {
    url: '/ratereserved/queryRateReservedPageInfo',
    method: 'post'
  }
}, {
  desc: '留点批次查询接口',
  options: {
    url: '/ratereserved/queryRateReservedBatchPageInfo',
    method: 'post'
  }
}, {
  desc: '留点批次新增编辑接口',
  options: {
    url: '/ratereserved/addOrUpdateRateReservedBatch',
    method: 'post'
  }
}, {
  desc: '获取机构负责人',
  options: {
    url: '/ratereserved/getChargeCustomer',
    method: 'post'
  }
}, {
  desc: '保存留点配置接口',
  options: {
    url: '/ratereserved/lotSaveRateReserved',
    method: 'post'
  }
}]
export default ratereserved



// WEBPACK FOOTER //
// ./src/api/ratereserved.js